import { FormGroup, AbstractControl } from "@angular/forms";
class FormGroupHelpersImpl 
{
    /**
     * Adds the returned AbstractControl from the `controlFactory` function if the `formGroup` doesn't already contain
     * a control with the given `name`.
     *
     * @param formGroup `FormGroup` to contain the control.
     * @param name Name of the control within the `formGroup`.
     * @param controlFactory Function that will return an `AbstractControl`.
     */
    tryAddControl(formGroup: FormGroup, name: string, controlFactory: () => AbstractControl): void 
    {
        if (formGroup.contains(name)) 
        {
            return;
        }

        formGroup.addControl(name, controlFactory());
    }
}

export const FormGroupHelpers = new FormGroupHelpersImpl();
